import React from 'react';
import ReactDOM from 'react-dom';
import {
  Normalize,
  ThemeProvider,
  SnackbarProvider,
} from '@medicalwebexperts/ui';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AuthenticationProvider from './components/AuthenticationProvider/AuthenticationProvider';
import reportWebVitals from './reportWebVitals';
import App from './components/App/App';
import theme from './themes/preset';
import 'typeface-poppins';
import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Normalize />
      <AuthenticationProvider>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </AuthenticationProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
